<template>
    <div class="col backgroundForm">
        <div class="col-12 col-md-10 offset-md-1">
            <h3 class="col" align="center">Reporte de Operaciones Pendientes</h3>
            <form @submit.prevent="mGenerateReport">
                <div class="btn-group btn-group-toggle col-12 col-md-10" data-toggle="buttons">
                    <label class="btn btn-success active" @click="mViewSearch">
                    <input class="form-check-input" type="radio" name="exampleRadios" id="exampleRadios1" v-model="optionSearch" value="enroll" checked> Matriculacion
                    </label>
                    <label class="btn btn-success" @click="mViewSearch">
                    <input class="form-check-input" type="radio" name="exampleRadios" id="exampleRadios2" v-model="optionSearch" value="oper"> Operacion
                    </label>
                    <label class="btn btn-success" @click="mViewSearch">
                    <input class="form-check-input" type="radio" name="exampleRadios" id="exampleRadios3" v-model="optionSearch" value="renew"> Renovacion
                    </label>
                    <label class="btn btn-success" @click="mViewSearch">
                    <input class="form-check-input" type="radio" name="exampleRadios" id="exampleRadios4" v-model="optionSearch" value="penalty"> Sanción
                    </label>
                </div>
                
                <div class="form-row">
                    <div class="form-group col offset-md-3 col-md-6">
                        <label for="captain_download" class="badge badge-info">CAPITANIA</label>
                        <transition name="fade" mode="out-in">
                            <select v-if="dRolUser" name="captain_download" class="form-control" id="captain_download" v-model="port_select">
                                <option v-for="port in port_local" :value="port" :key="port.id">{{ port.name_port }}</option>
                            </select>
                            <div v-else class="alert alert-success">
                                {{ cSessionUser.name_port }}
                            </div>
                        </transition>
                    </div>
                </div>

                <div class="form-row">
                    <div class="form-group col col-md-6">
                        <label for="date_init_discharge" class="badge badge-info">DEL:</label>         
                        <input type="date" class="form-control" id="date_init_discharge" name="date_init_discharge" v-model="date_init" placeholder="DD/MM/YYYY" autocomplete="off">
                    </div>
                    <div class="form-group col col-md-6">
                        <label for="date_end_discharge" class="badge badge-info">AL:</label>         
                        <input type="date" class="form-control" id="date_end_discharge" name="date_end_discharge" v-model="date_end" placeholder="DD/MM/YYYY" autocomplete="off">
                    </div>
                </div>
                <button class="btn btn-outline-primary col col-md-4 offset-md-4"><font-awesome-icon icon="print" /> Generar Reporte</button>
            </form>
        </div>
        <br>
        <modal-loading :id-modal="mlr" :title="d_r_t" :status-send="status_send"></modal-loading>
    </div>
</template>
<script>
import Vue from 'vue';
import modalLoading from '../modal/modalLoading';
import axios from 'axios';

export default {
    name:'reports-pending-operations',
    data(){
        return {
            optionSearch:'enroll',
            date_init:null,
            date_end:null,
            port_local:[],
            port_select:{id:0},
            dRolUser:null,
            mlr:'loadReportPending',
            d_r_t:'Generando Reporte',
            status_send:true
        }
    },
    mounted(){
        this.getToday(),
        this.chargeInit()
    },
    methods:{
        mViewSearch(event){
            var radios=$("input[type=radio]").parents('label');
            let radioV;
            setTimeout(()=>{
                for(let i=0;i<radios.length;i++){                    
                    if($(radios[i]).hasClass('active')){
                        radioV=$(radios[i]).children('input').attr('value');
                    }
                }
                this.optionSearch=radioV;
                this.debts_local=null;
            },200)                
        },
        async chargeInit(){
            //   llamar al loading hasta esperar que complete todos los datos del formulario hacer lo mismo en la aprobacion de la matricula
            // this.mShowModal(this.mlr)
            // const ports = await axios.get(`getPorts`);
            this.mShowModal(this.mlr);
            const ports = await axios.get(`getPorts?api_token=${Vue.auth.getToken()}`);
            this.port_local=ports.data;
            
            this.$store.dispatch('sDebtsP/clearDebts', true);
            this.$store.dispatch('sDocDebts/clearDocument', true);
            this.dRolUser= this.cSessionUser.role === 3 ? true:false;
            setTimeout(()=>{
                this.mCloseModal(this.mlr);
            }, 1200)
        },
        async mGenerateReport(){
            
            
            let auxPort=this.dRolUser ? this.port_select.id : this.cSessionUser.portId;
            
            if(auxPort > 0){
                this.mShowModal(this.mlr);
                axios.get(`pdfReportPending/${auxPort}/${this.optionSearch}/${this.date_init}/${this.date_end}?api_token=${Vue.auth.getToken()}`,
                // axios.get(`pdfReportPending/${auxPort}/${this.optionSearch}/${this.date_init}/${this.date_end}`,
                    {
                        responseType:'blob'
                    })
                    .then(res => {
                        // console.log(res)
                        // const url = window.URL.createObjectURL(new Blob([res.data]));
                        const url = window.URL.createObjectURL(new Blob([res.data]));
                        const link = document.createElement('a');
                        link.href = url;
                        link.setAttribute('download', 'CargosPendientes.pdf');
                        document.body.appendChild(link);
                        link.click();
                        setTimeout(()=>{
                            this.mCloseModal(this.mlr);
                        }, 1200)
                        
                    })
                    .catch(error => {
                        console.log(error);
                        setTimeout(()=>{
                            this.mCloseModal(this.mlr);
                        }, 1200)
                    })
            }else{
                toastr.error('Seleccione una Capitania');
            }
        },
        getToday(){
            let  today = new Date();
            let m = today.getMonth() + 1;
            let mes = (m < 10) ? '0' + m : m;
            let d = today.getDate();
            let dia= (d < 10) ? '0'+d : d;
            let date_aux=today.getFullYear()+'-'+mes+'-'+dia;
            this.date_init=date_aux;
            this.date_end=date_aux;            
        },
        mShowModal(m){
            $('#'+m).modal('show');
        },
        mCloseModal(m){
            $('#'+m).modal('hide');
        },
    },
    components:{
        'modal-loading':modalLoading
    },
    computed:{
        cSessionUser(){
            return this.$store.getters.getUserState;
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/reports/ReportsPendingOperations.vue